<template>
  <div class="content">
    <div class="content-logo">
      <img :src="data ? data.escudo : ''" width="100rem" height="100rem" />
    </div>
    <div class="text-center">
      <h5>
        {{ data ? data.baner.pais : '' }}
      </h5>
      <h5>
        {{ data ? data.baner.departamento : '' }}
      </h5>
      <h5>
        {{ data ? data.baner.municipio : '' }}
      </h5>      
      <p class="sub-item">
        {{ data ? data.baner.secretaria : '' }}
      </p>
      <p class="sub-item">
        {{ data ? data.baner.nit : '' }}
      </p>
    </div>
    <img class="flag" :src="data ? data.bandera : ''" width="100rem" height="60rem" />
  </div>
</template>

<script>

export default {
  name: "Header",
  props: {
    data: Object
  }
};
</script>

<style scoped>

.text-center{
    text-align: center;
}

.sub-item{
    margin-bottom: 0rem;
}

.content{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 3rem;
}


@media (max-width: 650px) {
  .content {
    display: block;
  }

  .flag{
    display: none;  
  }

  .content-logo{
    width: 100%;
    text-align: center;
  }
}

</style>
